import { FC } from 'react'
import { TenantAvatar, TenantAvatarType } from './Avatar'

export const Tenant: FC & TenantAvatarType = (): JSX.Element => <></>

Tenant.Avatar = TenantAvatar
